/* GET CALL_PRICES */
export const GET_ADMIN_CALL_PRICES = "GET_ADMIN_CALL_PRICES"
export const GET_ADMIN_CALL_PRICES_SUCCESS = "GET_ADMIN_CALL_PRICES_SUCCESS"
export const GET_ADMIN_CALL_PRICES_ERROR = "GET_ADMIN_CALL_PRICES_ERROR"

/* UPDATE CALL_PRICES */
export const UPDATE_ADMIN_CALL_PRICE = "UPDATE_ADMIN_CALL_PRICE"
export const UPDATE_ADMIN_CALL_PRICE_SUCCESS = "UPDATE_ADMIN_CALL_PRICE_SUCCESS"
export const UPDATE_ADMIN_CALL_PRICE_ERROR = "UPDATE_ADMIN_CALL_PRICE_ERROR"